function updateProductTickets(productInfo) {
  const quantity = Number(productInfo.querySelector('.quantity__input')?.value || 1);
  const ticketBadge = productInfo.querySelector('.cus_ticket[data-ticket]');
  const ticketValue = ticketBadge?.dataset.ticket;
  if (!ticketValue?.trim()) return;
  const tickets = Number(ticketValue);
  if (!Number.isFinite(tickets) || !Number.isInteger(quantity) || quantity < 1) return;
  const total = tickets * quantity;
  ticketBadge.textContent = String(total);
  const field = productInfo.querySelector('input[name="properties[Ticket]"]');
  if (field) field.value = `${total} Tickets`;
}

function updateCartTicketCount() {
  let total = 0;
  document.querySelectorAll('.cart-item .cus_tickitnumber[data-ticket_no]').forEach((item) => {
    const tickets = Number(item.dataset.ticket_no);
    if (Number.isFinite(tickets)) total += tickets;
  });
  document.querySelectorAll('.totaal-ticket-count').forEach((item) => {
    item.textContent = `${total} Tickets`;
  });
}

document.addEventListener('change', (event) => {
  if (!event.target.matches('.quantity__input')) return;
  const productInfo = event.target.closest('product-info');
  if (productInfo) updateProductTickets(productInfo);
});

document.addEventListener('click', (event) => {
  if (event.target.closest('.cst_pay_btn')) document.querySelector('.cart__checkout-button.button')?.click();
});

subscribe(PUB_SUB_EVENTS.variantChange, ({ data: { sectionId, html } }) => {
  document.querySelectorAll('product-info').forEach((productInfo) => {
    if ((productInfo.dataset.originalSection || productInfo.dataset.section) !== sectionId) return;
    const sourceField = html.querySelector('input[name="properties[Ticket]"]');
    const field = productInfo.querySelector('input[name="properties[Ticket]"]');
    if (sourceField && field) field.value = sourceField.value;
    updateProductTickets(productInfo);
  });
});

subscribe(PUB_SUB_EVENTS.cartUpdate, () => requestAnimationFrame(updateCartTicketCount));
document.addEventListener('DOMContentLoaded', updateCartTicketCount);
